import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MdbNotificationModule } from 'src/lib/mdb5-adapted/public-api';
import { NotificationComponent } from './notification.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MdbNotificationModule,
    NotificationComponent
  ],
  exports: [NotificationComponent]
})
export class NotificationModule { }
